import Cookies from 'js-cookie';
import AOS from 'aos';

/**
 * Animation on scroll
 */
 function aos_init() {
    AOS.init({
    duration: 1000,
    easing: "ease-in-out",
    once: true,
    mirror: false
    });
}
window.addEventListener('load', () => {
    aos_init();
});

$(function() {

    if (window.innerWidth < 960) {

        $('.has-children').on('click', function(e){
            $('.subul').removeClass('show')
            $(this).find('ul').addClass('show')
        })

    }

    $('#menuToggler').on('click', function(){
        $('#bottomheader').toggleClass('open')
        $(this).toggleClass('active');
    })

    var lastScrollTop = 0, delta = 5;
    $(window).scroll(function(){
        var nowScrollTop = $(this).scrollTop();
        if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
            if (nowScrollTop > lastScrollTop){
                $('#header').addClass('hide');
            } else {
                $('#header').removeClass('hide');
            }
            lastScrollTop = nowScrollTop;
        }
    });

    $('#anchor').on('click', function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    })

    var alerte = $('.alert-dismissible')
    if(alerte.length){
        setTimeout(function() {
            alerte.addClass('alerte-remove')
        }, 15000);
    }


})
